@if (corporateTaxEntity$ | async) {
<form [formGroup]="balansEnResultatenRekeningFg">

  <div class="d-flex mb-2" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px;"></div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2">
        <p style="width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin: 0;">{{ item.value.naamVennootschap }}</p>
      </div>
    </div>
    }
  </div>

  <div class="d-flex" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px">
      <p>Goodwill</p>
    </div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2" formGroupName="goodwill">
        @for (_ of item.get('goodwill')?.value; track $index; let j = $index) {
        <div [formGroupName]="j">
          <snelstart-ui-number-form-control
                                            class="custom-input-150"
                                            [prefix]="i === index - 2 ? '€  -' : '€'"
                                            [showAllDecimals]="false"
                                            align="right"
                                            formControlName="openingsbalans"
                                            id="goodwill"
                                            [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
          </snelstart-ui-number-form-control>
        </div>
        }
      </div>
    </div>
    }
  </div>

  <div class="d-flex" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px">
      <p>Overige immateriele activa</p>
    </div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2" formGroupName="overigeImmaterieleActiva">
        @for (_ of item.get('overigeImmaterieleActiva')?.value; track $index; let j = $index) {
        <div [formGroupName]="j">
          <snelstart-ui-number-form-control
                                            class="custom-input-150"
                                            [prefix]="i === index - 2 ? '€  -' : '€'"
                                            [showAllDecimals]="false"
                                            align="right"
                                            formControlName="openingsbalans"
                                            id="overigeImmaterieleActiva"
                                            [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
          </snelstart-ui-number-form-control>
        </div>
        }
      </div>
    </div>
    }
  </div>


  <div class="d-flex" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px">
      <p>Gebouwen en terreinen</p>
    </div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2" formGroupName="gebouwenEnTerreinen">
        @for (_ of item.get('gebouwenEnTerreinen')?.value; track $index; let j = $index) {
        <div [formGroupName]="j">
          <snelstart-ui-number-form-control
                                            class="custom-input-150"
                                            [prefix]="i === index - 2 ? '€  -' : '€'"
                                            [showAllDecimals]="false"
                                            align="right"
                                            formControlName="openingsbalans"
                                            id="gebouwenEnTerreinen"
                                            [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
          </snelstart-ui-number-form-control>
        </div>
        }
      </div>
    </div>
    }
  </div>


  <div class="d-flex" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px">
      <p>Machines en installaties</p>
    </div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2" formGroupName="machinesEnInstallaties">
        @for (_ of item.get('machinesEnInstallaties')?.value; track $index; let j = $index) {
        <div [formGroupName]="j">
          <snelstart-ui-number-form-control
                                            class="custom-input-150"
                                            [prefix]="i === index - 2 ? '€  -' : '€'"
                                            [showAllDecimals]="false"
                                            align="right"
                                            formControlName="openingsbalans"
                                            id="machinesEnInstallaties"
                                            [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
          </snelstart-ui-number-form-control>
        </div>
        }
      </div>
    </div>
    }
  </div>


  <div class="d-flex" formArrayName="balansEnResultatenrekening">
    <div class="col col-1" style="min-width: 308px">
      <p>Andere vaste activa</p>
    </div>
    @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="col-2" formGroupName="andereVasteActiva">
        @for (_ of item.get('andereVasteActiva')?.value; track $index; let j = $index) {
        <div [formGroupName]="j">
          <snelstart-ui-number-form-control
                                            class="custom-input-150"
                                            [prefix]="i === index - 2 ? '€  -' : '€'"
                                            [showAllDecimals]="false"
                                            align="right"
                                            formControlName="openingsbalans"
                                            id="andereVasteActiva"
                                            [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
          </snelstart-ui-number-form-control>
        </div>
        }
      </div>
    </div>
    }
  </div>

  <div class="pt-3">
    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Langlopende vord. groepsmaatschappijen</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="vorderingenLangGroepsmaatschappijen">
          @for (_ of item.get('vorderingenLangGroepsmaatschappijen')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
                                              class="custom-input-150"
                                              [prefix]="i === index - 2 ? '€  -' : '€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="vorderingenLangGroepsmaatschappijen"
                                              [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>


    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Langlopende vord. participanten</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="vorderingenLangParticipanten">
          @for (_ of item.get('vorderingenLangParticipanten')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
                                              class="custom-input-150"
                                              [prefix]="i === index - 2 ? '€  -' : '€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="vorderingenLangParticipanten"
                                              [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>


    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Overige financiële activa</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="overigeFinancieelVasteActiva">
          @for (_ of item.get('overigeFinancieelVasteActiva')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
                                              class="custom-input-150"
                                              [prefix]="i === index - 2 ? '€  -' : '€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="overigeFinancieelVasteActiva"
                                              [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>


    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Deelnemingen</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="deelnemingen">
          @for (_ of item.get('deelnemingen')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
                                              class="custom-input-150"
                                              [prefix]="i === index - 2 ? '€  -' : '€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="deelnemingen"
                                              [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>

  <div class="pt-3">
    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Voorraden</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="voorraden">
          @for (_ of item.get('voorraden')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
                                              class="custom-input-150"
                                              [prefix]="i === index - 2 ? '€  -' : '€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="voorraden"
                                              [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
            </snelstart-ui-number-form-control>

          </div>
          }
        </div>
      </div>
      }
    </div>


    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Onderhanden werk</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="onderhandenWerk">
          @for (_ of item.get('onderhandenWerk')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
                                              class="custom-input-150"
                                              [prefix]="i === index - 2 ? '€  -' : '€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="onderhandenWerk"
                                              [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>


    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Debiteuren</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="vorderingDebiteuren">
          @for (_ of item.get('vorderingDebiteuren')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
                                              class="custom-input-150"
                                              [prefix]="i === index - 2 ? '€  -' : '€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="vorderingDebiteuren"
                                              [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>


    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Omzetbelasting</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="vorderingenOmzetbelasting">
          @for (_ of item.get('vorderingenOmzetbelasting')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
                                              class="custom-input-150"
                                              [prefix]="i === index - 2 ? '€  -' : '€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="vorderingenOmzetbelasting"
                                              [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Kortlopende vord. groepsmaatschappijen</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="vorderingenKortGroepsmaatschappijen">
          @for (_ of item.get('vorderingenKortGroepsmaatschappijen')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
                                              class="custom-input-150"
                                              [prefix]="i === index - 2 ? '€  -' : '€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="vorderingenKortGroepsmaatschappijen"
                                              [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Kortlopende vord. participanten</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="vorderingenKortParticipanten">
          @for (_ of item.get('vorderingenKortParticipanten')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
                                              class="custom-input-150"
                                              [prefix]="i === index - 2 ? '€  -' : '€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="vorderingenKortParticipanten"
                                              [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Overige vorderingen</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="vorderingenOverig">
          @for (_ of item.get('vorderingenOverig')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
                                              class="custom-input-150"
                                              [prefix]="i === index - 2 ? '€  -' : '€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="vorderingenOverig"
                                              [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>

  <div class="pt-3">
    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Effecten</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="effecten">
          @for (_ of item.get('effecten')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
                                              class="custom-input-150"
                                              [prefix]="i === index - 2 ? '€  -' : '€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="effecten"
                                              [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p>Liquide middelen</p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="liquideMiddelen">
          @for (_ of item.get('liquideMiddelen')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control
                                              class="custom-input-150"
                                              [prefix]="i === index - 2 ? '€  -' : '€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="liquideMiddelen"
                                              [disabledControl]="item.get('naamVennootschap')?.value === 'Consolidatie'">
            </snelstart-ui-number-form-control>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>

  <div class="pt-3">
    <div class="d-flex" formArrayName="balansEnResultatenrekening">
      <div class="col col-1" style="min-width: 308px">
        <p><b>Totaal activa</b></p>
      </div>
      @for (item of balansEnResultatenrekening.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="col-2" formGroupName="totaal">
          @for (_ of item.get('totaal')?.value; track $index; let j = $index) {
          <div [formGroupName]="j">
            <div>
              <snelstart-ui-number-form-control
                                                [showAllDecimals]="false"
                                                align="right"
                                                class="custom-input-150 custom-readonly"
                                                formControlName="totaalActivaOpen"
                                                id="totaal"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>
</form>
}
